import React from 'react';
import { Dumbbell, BookOpen, Music, BarChart2, FileText, Apple } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const DISCOVER_IMG =
  'https://images.unsplash.com/photo-1517836357463-d25dfeac3438?auto=format&fit=crop&w=600&q=80';

const icons = [Dumbbell, Apple, BarChart2, Music, BookOpen, FileText];

const Features = () => {
  const { t } = useLanguage();

  return (
    <section id="oppdag" className="py-24 relative bg-[#080d18]">
      <div className="absolute inset-0 opacity-40 pointer-events-none bg-[radial-gradient(ellipse_at_30%_0%,rgba(212,160,36,0.08),transparent_50%)]" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="grid lg:grid-cols-2 gap-14 items-center mb-20">
          <div>
            <span className="text-accent text-sm font-bold uppercase tracking-[0.2em]">{t.discover.kicker}</span>
            <h2 className="mt-4 text-4xl lg:text-5xl font-extrabold text-white font-heading leading-tight">
              {t.discover.title}{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary-light to-accent">
                {t.discover.titleGrad}
              </span>
            </h2>
          </div>
          <div>
            <p className="text-lg text-slate-400 leading-relaxed">{t.discover.body}</p>
            <div className="mt-8 flex items-center gap-5">
              <img
                src={DISCOVER_IMG}
                alt=""
                className="w-28 h-28 rounded-2xl object-cover shadow-xl ring-2 ring-primary/20"
                width={112}
                height={112}
              />
              <div>
                <p className="text-white font-semibold">{t.discover.devicesTitle}</p>
                <p className="text-slate-500 text-sm mt-1">{t.discover.devicesSub}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="mb-6">
          <span className="text-primary-light text-sm font-bold uppercase tracking-[0.2em]">{t.features.kicker}</span>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {t.features.items.map((item, index) => {
            const Icon = icons[index % icons.length];
            return (
              <div
                key={item.title}
                className="group bg-card-dark border border-border-dark rounded-2xl p-7 hover:border-primary/35 hover:shadow-glow/50 transition-all duration-300 hover:-translate-y-1"
              >
                <div className="w-12 h-12 bg-primary/10 border border-primary/20 rounded-xl flex items-center justify-center mb-5 group-hover:bg-primary/20 transition-colors">
                  <Icon className="w-6 h-6 text-primary-light" />
                </div>
                <h3 className="text-lg font-bold text-white mb-2 font-heading">{item.title}</h3>
                <p className="text-slate-400 text-sm leading-relaxed">{item.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Features;
